import { MAX_NUMBER_LIMIT } from 'appConstants';
import { t } from 'i18next';
import * as yup from 'yup';

import type { IValidationField } from '../types';

export default function positiveNumberConditionalRequired({
  label = '',
  context,
}: IValidationField) {
  const { maxValue = MAX_NUMBER_LIMIT, field = '' } = context || {};

  return yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .label(label)
    .min(1)
    .when(field, {
      is: (val: boolean) => val,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema,
    })
    .positive()
    .max(maxValue)
    .test({
      name: 'valid_integer',
      test: (value, context) => {
        const regex = /^[0-9]*$/g;
        const { originalValue = '', path = '' } = context;
        if (!originalValue.toString().match(regex)) {
          return context.createError({
            message: t('errors.integerNumber'),
            path: path,
          });
        }

        return true;
      },
    })
    .integer(`${t('errors.integerNumber')}`)
    .typeError(`${t('errors.integerNumber')}`);
}
